/**
 * ACCPAY URL Building Utilities
 *
 * Provides consistent URL generation for ACCPAY pages,
 * following the same pattern as compliance-url-mapping.ts
 */

/**
 * Build URL for ACCPAY pages with client/entity context
 * Pattern: /accpay/{page}/{clientId}/{entityId}
 */
export function buildAccpayUrl(
  page: 'all' | 'prepayments',
  clientId: string | null,
  entityId: string | 'all' | null
): string {
  if (!clientId) {
    console.warn('buildAccpayUrl: No clientId provided, redirecting to dashboard');
    return '/dashboard';
  }

  // If entity is 'all' or null, only include clientId
  if (!entityId || entityId === 'all') {
    return `/accpay/${page}/${clientId}`;
  }

  return `/accpay/${page}/${clientId}/${entityId}`;
}
